export const EN_LOCALE = 'en';
export const EN_LOCALE_TITLE = 'English';
export const DEFAULT_LOCALE = EN_LOCALE;
